import { makeAutoObservable, observable } from 'mobx';
import { getEnterFlow2026Value } from 'utils/ab-test/abTests';

import { RootStore } from './RootStore';

/** @deprecated This need to be thrown away once we get rid of Plasmic, in favour of simply using functions directly
 * from utils/ab-test/abTests.ts
 *
 * WARNING: ABTestStore may provide out of date information on the first page load. This is because it may be
 * initialised before any of the ABTest variants are created for the first time */
export class ABTestStore {
  root: RootStore;
  abTests = observable.map<string, string>();

  constructor(root: RootStore) {
    this.root = root;
    makeAutoObservable(this);

    // Force any AB test values that we know we're going to need, so that they are in local storage before
    // updateABTestValuesFromLocalStorage gets called
    getEnterFlow2026Value();

    this.updateABTestValuesFromLocalStorage();
  }

  updateABTestValuesFromLocalStorage = () => {
    if (typeof window === 'undefined') return;

    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (key && key.startsWith('ABTest_')) {
        const value = localStorage.getItem(key);
        if (value) {
          const testKey = key.substring('ABTest_'.length);

          const lastUnderscoreIndex = testKey.lastIndexOf('_');
          let testName;

          if (lastUnderscoreIndex !== -1) {
            testName = testKey.substring(0, lastUnderscoreIndex);
          } else {
            testName = testKey;
          }

          // Store in abTests
          this.abTests.set(testName, value);
        }
      }
    }
    // Overcomplicate way needed to log an observable map
    console.log(
      'ABTestStore',
      JSON.stringify(Array.from(this.abTests.entries())),
    );
  };

  getABTestValue = (testName: string) => {
    return this.abTests.get(testName) || undefined;
  };
}
